import { useEffect, useState } from "react";

// Renders the product photo; on load error falls back to the local SVG so a
// card never shows a broken image. `override` lets a caller swap in the
// pack-size specific artwork when a size is selected.
export default function ProductImage({ product, className, override }) {
  const primary = override || product.photo || product.fallback;
  const [src, setSrc] = useState(primary);

  // Follow the selected pack size.
  useEffect(() => {
    setSrc(primary);
  }, [primary]);

  return (
    <img
      className={className}
      src={src}
      alt={product.name}
      loading="lazy"
      width="240"
      height="240"
      onError={() => {
        if (src !== product.fallback) setSrc(product.fallback);
      }}
    />
  );
}
